import { Observable } from "rxjs";
import { config } from "../../config/config";
import { utilService } from "../utils";

/**
 * Api services for web logs component
 */
export const webLogsService = {
  savePageVisitLogs,
  getPageVisitLogs,
};

function savePageVisitLogs(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.weblogs, {
      method: "POST",
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getPageVisitLogs(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.weblogs + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
